<template>
  <div class="text-center">
    <AddImageIcon />
  </div>
</template>

<script>
import AddImageIcon from "../icons/AddImageIcon";
export default {
  components: {
    AddImageIcon,
  },
};
</script>

<style lang="scss" scoped>
</style>